import { render } from "./verificarTarjeta.vue?vue&type=template&id=47639d4f"
import script from "./verificarTarjeta.vue?vue&type=script&lang=js"
export * from "./verificarTarjeta.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__